<template>
  <div class="next" @click="$emit('click')"></div>
</template>

<script>
export default {
  name: "Next"
};
</script>

<style lang="scss" scoped>
.next {
  width: 28px;
  height: 28px;
  background-image: url(~/images/箭头2.png);
  background-size: contain;
  cursor: pointer;
}

.next:hover {
  background-image: url(~/images/箭头2悬停.png);
}
</style>